import {addProject, getProjects} from '@/models/project';
import JwtService from '@/services/jwt.service';


export default {
  async aInit({commit}) {
    const user = JwtService.getUser();
    const params = {userId: user.id};
    let projects  = await getProjects(params);
    commit('mInit', projects);
  },
  async aAdd ({commit}, project)  {
    const user = JwtService.getUser();
    let p = {...project};
    delete p.id;
    p.userId = user.id;
    project = await addProject(p);
    // console.log(project);
    commit('mAdd', project);
    commit('mCloseDialog');
  },
  async aUpdate ({commit}, project)  {
    await updateProject(project);
    commit('mCloseDialog');
  },
  move (state, getters, rootState, id) {

  },
  get (state, getters, rootState, id) {

  },
  update (state, getters, rootState, id) {

  },
  delete (state, getters, rootState, id) {

  },
  list (state, getters, rootState, id) {

  }
};
